var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6947 0C6.15216 0 0.83139 5.3816 0.83139 11.9968C0.83139 18.6112 6.15295 23.9904 12.6947 23.9904C19.2365 23.9904 24.5628 18.6104 24.5628 11.9968C24.5628 5.3816 19.2373 0 12.6947 0ZM12.6947 23.1296C6.6222 23.1296 1.68283 18.1376 1.68283 11.9968C1.68283 5.856 6.6222 0.860791 12.6947 0.860791C18.7688 0.860791 23.7113 5.856 23.7113 11.9968C23.7113 18.1376 18.7688 23.1296 12.6947 23.1296ZM18.044 10.8608L10.6159 6.69199C9.60384 6.12319 8.63449 6.7264 8.63449 7.872V16.1192C8.63449 16.9616 9.11323 17.5288 9.82461 17.5288C10.081 17.5288 10.3485 17.452 10.6175 17.3008L18.044 13.1304C18.5354 12.8552 18.8186 12.4416 18.8186 11.9976C18.8186 11.5536 18.5354 11.1392 18.044 10.8608ZM17.6301 12.3768L10.2052 16.5472C10.0644 16.6256 9.93461 16.6672 9.82541 16.6672C9.53184 16.6672 9.48672 16.3248 9.48672 16.1184V7.872C9.48672 7.6672 9.53184 7.3248 9.82541 7.3248C9.9354 7.3248 10.0652 7.3672 10.2052 7.4448L17.6301 11.6136C17.8374 11.7304 17.9672 11.8776 17.9672 11.9968C17.9664 12.1144 17.8366 12.2608 17.6301 12.3768Z",
    fill: "#A161BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5306,
    height: 24,
    fill: "white",
    transform: "translate(0.43573)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOutline);
export default __webpack_public_path__ + "static/media/PlayOutline.dde062cf07e0216ab0b1a1292a61b553.svg";
export { ForwardRef as ReactComponent };